export default __webpack_public_path__ + "static/media/L0002.db31ac9b.png";